<template>
    <div class="container p-t-md p-b-lg" id="status">
        <b-collapse
            class="card"
            animation="slide"
            v-for="(app, index) of apps"
            :key="index"
            :open="testResults[app.referrer] && testResults[app.referrer].length ? true : false"
            >
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                >
                    <p class="card-header-title">
                        {{ app.name }} 
                        <!-- <span v-if="testResults[app.referrer]">({{testResults[app.referrer].length}})</span>
                        <span v-else>(0)</span> -->
                    </p>
                    <div class="card-header-icon">
                        
                        <span :class="'circle '+app.class"></span>
                    </div>
                </div>
            </template>
            <div class="card-content">
                <div class="content">
                    <b-collapse class="card"
                        animation="slide"
                        v-for="(item, index) in testResults[app.referrer]" :key="index"
                    >
                        <template #trigger="props">
                            <div
                                class="card-header"
                                role="button"
                            >
                                <p class="card-header-title">
                                    {{ item.name }} {{item.created_at}}
                                </p>
                                <div class="card-header-icon">
                                    <span :class="'circle '+(item.status==='success' ? 'is-success' : 'is-danger')">
                                    </span>
                                </div>
                            </div>
                        </template>
                    </b-collapse>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    data(){
        return {
            isOpen: null,
            apps:[],
            testResults:{}
        }
    },
    computed:{
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
    },
    async mounted(){
        await this.getApps()
    },
    methods:{
        async getApps(page = 1){
            this.loading = true;
            await Vue.$appService.appList('?page='+page+'&report_status=1').then((response)=>{
                this.apps = response
                return this.apps
            }).then(async()=>{
                let apps = []
                var key;
                for(key in this.apps){
                    let element = this.apps[key]
                    await Vue.$appService.isUp(element.id).then((response)=>{
                        if(response.status===200 || element.referrer.includes(process.env.VUE_APP_URL) || process.env.VUE_APP_URL.includes(element.referrer)){
                            element.class='is-success'
                        }else{
                            element.class = 'is-danger'
                        }
                        apps.push(element)
                    }).then(async ()=>{
                        await Vue.$testResultService.getAsOptions('?application_id='+element.id+'&groupBy=name').then((response)=>{
                            this.testResults[element.referrer] = response.data
                        })
                    })
                }

                this.apps = apps
            })
            this.loading = false
            return true;
        },
    }
}
</script>